import {
	galleryImage,
	mediaFlyer1,
	mediaFlyer2,
	mediaFlyer3,
	mediaFlyer4,
	mediaFlyer5,
	mediaFlyer6,
} from "../images/media";

export const heroData = [
	{
		imageSource: [galleryImage, galleryImage],
		heading: "Media Room",
	},
];

export const imagesData = [
	{
		imageSource: [mediaFlyer1, mediaFlyer1],
		imageName: "Image 1",
		section: "Picture 1",
		title: "Place holder",
	},
	{
		imageSource: [mediaFlyer2, mediaFlyer2],
		imageName: "Image 2",
		section: "Picture 2",
		title: "Place holder",
	},
	{
		imageSource: [mediaFlyer3],
		imageName: "Image 3",
		section: "Picture 3",
		title: "Place holder",
	},
	{
		imageSource: [mediaFlyer4],
		imageName: "Image 4",
		section: "Picture 4",
		title: "Place holder",
	},
	{
		imageSource: [mediaFlyer5],
		imageName: "Image 5",
		section: "Picture 5",
		title: "Place holder",
	},
	{
		imageSource: [mediaFlyer6],
		imageName: "Image 6",
		section: "Picture 6",
		title: "Place holder",
	},
];
